import LoginRequest from '@/components/organisms/login-request/login-request';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';
import { graphql, useStaticQuery } from 'gatsby';
import useMobile from '@/hooks/useMobile';
import { getMonetaryFee } from '@/services/certificate-services';
import useLoginGigya from '@/shared/hooks/useLoginGigya';
import { useEffect, useState } from 'react';
import { getYearMonth, getYearMonthPastDate } from '@/utils/dateUtils';
import Breadcrumb from '@/components/atoms/breadcrumb/breadcrumb';
import './index.scss';
import useBrowserMode from '@/shared/hooks/useBrowserMode';
import ExpiredSubsidies from '@/components/organisms/expired-subsidies/expired-subsidies';
import Tabs from '@/components/organisms/tabs/Tabs';
import { extractFormattedText } from '@/utils/stringUtils';

const Prueba = () => {
    const metaDataQuery = useStaticQuery(graphql`
        query GET_EXPIRED_SUBSIDIES {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Interna de certificados > Consulta de subsidios monetarios próximos a vencer"
                    }
                }
            ) {
                nodes {
                    referencias {
                        ... on ContentfulTemplate {
                            ... on ContentfulTemplate {
                                titulo
                                nombre
                                imagen {
                                    title
                                    url
                                }
                            }
                        }
                    }
                    nombre
                    subtitulo
                    titulo
                    descripcion {
                        raw
                    }
                    migaDePan
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        urlCanonical
                        noIndex
                        metaImagen {
                            gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                            title
                            url
                        }
                    }
                    nombre
                    titulo

                    subtitulo
                }
            }
        }
    `);

    const { metaInfo, nombre, subtitulo, migaDePan, referencias, descripcion } =
        metaDataQuery.allContentfulTemplate.nodes[0];

    const mobile = useMobile();
    const [currentTab, setCurrentTab] = useState({
        name: 'Mis datos',
        index: 0,
    });
    const gigyaContext = useLoginGigya();
    const [tableDataMonetary, setTableDataMonetary] = useState<any>(['']);
    const [tableDataAlimentary, setTableDataAlimentary] = useState<any>(['']);
    const [loading, setLoading] = useState(true);
    const [, setNoData] = useState(false);
    const [referencesData, setReferencesData] = useState<any>([]);
    const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
    const isBrowser = typeof window !== 'undefined';
    const { localStorage: local } = useBrowserMode();
    const storedTheme =
        isBrowser && local.getItem('class_theme') === 'dark-mode';

    const newReference = [...referencias];

    const lista = [
        'Fecha de pago',
        'Periodo pagado',
        'Valor pagado',
        'Medio de pago',
        'Fecha de vencimiento',
        'Estado',
    ];

    const handleMonetaryFee = async () => {
        const initialPeriod = getYearMonthPastDate(1200);
        const finalPeriod = getYearMonth();
        const userDocument = await gigyaContext?.gigyaAccount?.data.docNumber;
        const userTypeDocument = '1';

        setLoading(true);

        const dataSubs = await getMonetaryFee(
            userDocument,
            initialPeriod,
            finalPeriod,
            userTypeDocument
        );
        try {
            const nutritionalData =
                dataSubs?.data.data.detalleCuentaReportList?.filter(
                    (item) =>
                        item.tipoSubsidio ===
                        'Comprobante Nutricional Prescrito'
                );

            const subsData = dataSubs?.data.data.detalleCuentaReportList?.filter((item) => {

                const fechaVencimientoStr = item.fechaVencimiento;
                const year = parseInt(fechaVencimientoStr.substring(0, 4), 10);
                const month = parseInt(fechaVencimientoStr.substring(4, 6), 10) - 1;
                const day = parseInt(fechaVencimientoStr.substring(6, 8), 10);
                const fechaVencimiento = new Date(year, month, day);


                const fechaActual = new Date();


                const diasVencidos = (fechaActual.getTime() - fechaVencimiento.getTime()) / (1000 * 60 * 60 * 24);


                return (
                    (item.prescripcion === 'Proximo a prescribir' || item.prescripcion === 'Prescrito') &&
                    diasVencidos <= 15
                );
            });


            setTableDataMonetary(subsData);
            setTableDataAlimentary(nutritionalData);

            if (
                (dataSubs.status === 200 && nutritionalData.length === 0) ||
                (dataSubs.status === 200 && subsData.length === 0)
            ) {
                setNoData(true);
            }

            setLoading(false);
        } catch (error) {
            console.error(error);
        }
        return dataSubs;
    };

    useEffect(() => {
        if (storedTheme) {
            setIsDarkMode(true);
        } else {
            setIsDarkMode(false);
        }
    }, [storedTheme]);

    useEffect(() => {
        setReferencesData(newReference);

        if (
            tableDataAlimentary.length === 0 &&
            tableDataMonetary.length !== 0
        ) {
            setCurrentTab({ name: 'Cuota monetaria', index: 0 });
            setReferencesData(newReference.splice(0, 1));
        }
        if (
            tableDataAlimentary.length !== 0 &&
            tableDataMonetary.length === 0
        ) {
            setCurrentTab({ name: 'Subsidio alminetación', index: 1 });
            setReferencesData(newReference.splice(newReference.length - 1, 1));
        }
    }, [tableDataAlimentary, tableDataMonetary]);

    useEffect(() => {
        gigyaContext.gigyaAccount &&
            setTimeout(() => {
                handleMonetaryFee();
            }, 2000);
    }, [gigyaContext.gigyaAccount]);

    const description = `${extractFormattedText(JSON.parse(descripcion.raw))}`;

    return (
        <GeneralPageTemplate
            data={metaInfo}
            hasLoader={false}
            isPrivate={false}
            isActive={true}
        >
            <>
                {!gigyaContext.gigyaAccount ? (
                    <LoginRequest />
                ) : (
                    <div
                        className={
                            isDarkMode ? 'container dark-theme' : 'container'
                        }
                    >
                        <Breadcrumb content={migaDePan} />

                        <div className="header">
                            <h1 className="header__title">{nombre}</h1>
                            <p className="header__description">{subtitulo}</p>
                            <p className="header__subtitle">{description}</p>
                        </div>
                        <div className={'tabs__cont'}>
                            <Tabs
                                setCurrentTab={setCurrentTab}
                                currentTab={currentTab}
                                data={referencesData}
                            />
                        </div>

                        {currentTab.index === 0 && (
                            <ExpiredSubsidies
                                lista={lista}
                                loading={loading}
                                mobile={mobile}
                                noData={tableDataMonetary.length === 0}
                                setNoData={setNoData}
                                tableDataMonetary={tableDataMonetary}
                                redirectURL="/personas/certificados/consulta-pago-subsidio-familiar"
                            />
                        )}

                        {currentTab.index === 1 && (
                            <ExpiredSubsidies
                                lista={lista}
                                loading={loading}
                                mobile={mobile}
                                noData={tableDataAlimentary.length === 0}
                                setNoData={setNoData}
                                tableDataMonetary={tableDataAlimentary}
                                redirectURL="/personas/certificados/consulta-pago-subsidio-familiar"
                            />
                        )}
                    </div>
                )}
            </>
        </GeneralPageTemplate>
    );
};

export default Prueba;
